module.exports = __webpack_public_path__ + "static/media/trial1_1.4c22ca33.png";